/** The activity headline: distance · elapsed, then date, pool · length count, and device on their own rows. */
import { store } from '../state/store'
import { formatActivityDate, formatDistance, formatDuration } from '../analytics/format'

export function Headline() {
  const s = store.stats.value
  const poolCm = store.poolLengthCm.value
  if (!s || poolCm === null) return null

  const poolM = poolCm / 100
  const date = s.startTimeFitEpoch !== null ? formatActivityDate(s.startTimeFitEpoch) : null
  const pool = `${poolM % 1 === 0 ? poolM : poolM.toFixed(2)} m pool · ${s.activeLengths} lengths`

  return (
    <div class="headline">
      <div class="big">
        {formatDistance(s.distanceM, s.unit)} · {formatDuration(s.movingMs)}
      </div>
      {date && <div class="sub">{date}</div>}
      <div class="sub">{pool}</div>
      {s.device && <div class="sub">{s.device}</div>}
    </div>
  )
}
